<template>
  <div>
    <v-card>
      <v-img max-height="85" src="@/assets/img/background.png">
        <v-app-bar flat class="mt-2" color="rgba(0, 0, 0, 0)">
          <v-btn color="white" @click="goBack()" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <p class="text-white-title mt-4">Simpanan</p>
        </v-app-bar>
      </v-img>
    </v-card>
    <div class="mx-3 mt-6">
      <!-- <p class="app-subtitle mb-0 pb-0 mt-5">Filter:</p> -->
      <v-row>
        <v-col cols="6" class="mb-0 pb-0 text-center">
          <v-btn
            @click="showsaham('saham')"
            :color="label === 'Saham' ? 'primary' : '#ffffff'"
            width="100%"
            large
          >
            <v-icon>mdi-chart-line</v-icon> &nbsp;
            <span>Saham</span>
          </v-btn></v-col
        >
        <v-col cols="6" class="mb-0 pb-0 text-center">
          <v-btn
            width="100%"
            :color="label === 'Non Saham' ? 'primary' : '#ffffff'"
            @click="showsaham('nonsaham')"
            large
          >
            <v-icon>mdi-credit-card</v-icon> &nbsp;
            <span>Non Saham</span>
          </v-btn></v-col
        >
      </v-row>
    </div>
    <div class="mx-3 mt-5" v-if="label !== null">
      <p class="app-title">{{ label }}</p>
    </div>
    <v-card class="mx-3" v-if="showData">
      <div two-line :key="index.id" v-for="(row, index) in itemData">
        <v-list-item
          class="border-top"
          v-if="row.starting_balance !== 0 || row.ending_balance !== 0"
        >
          <v-list-item-content>
            <v-list-item-title>
              <p class="text-bold">
                {{
                  row.saving_type_details.formated ||
                    "SIMPANAN " + row.saving_type_details.plain
                }}
              </p>
            </v-list-item-title>
            <v-list-item-subtitle>
              <div class="d-flex justify-space-between pb-1">
                <span class="text-grey">Saldo Awal:</span>
                <span class="text-bold">
                  {{ row.starting_balance | currency }}</span
                >
              </div>
              <div class="d-flex justify-space-between pt-1">
                <span class="text-grey">Saldo Akhir:</span>
                <span class="text-bold">
                  {{ row.ending_balance | currency }}</span
                >
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              v-if="row.paid_off !== true"
              @click="goToDetail(row)"
              fab
              dark
              small
              class="mt-9"
              color="white"
            >
              <v-icon color="black">
                mdi-chevron-right
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </div>
    </v-card>
    <div
      class="not-found text-center d-flex flex-column  justify-center"
      v-if="itemData.length < 1"
    >
      <img
        src="@/assets/img/data_not_found.png"
        class="img-not-found-center"
        alt="Data Not Found"
      />
      <p class="text-bold-xl my-0 py-0">You Have No Savings</p>
      <p class="py-0 my-0">
        Register immediately, through CS at the Karyatama Cooperative
      </p>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const simpanan = createNamespacedHelpers("simpanan");

export default {
  name: "Home",
  panel: [],
  inject: {
    theme: {
      default: { isDark: false }
    }
  },
  computed: {
    ...simpanan.mapState(["res_saldoakhirsim"]),
    showData() {
      return this.itemData.length > 0;
    }
  },
  mounted() {
    this.$store.dispatch("simpanan/getSaltoAkhir");
    this.label = "Non Saham";
  },
  data() {
    return {
      url: process.env.VUE_APP_URL,
      itemData: [],
      show: true,
      showSahamdata: false,
      showNonSaham: true,
      headers: [
        {
          text: "Dessert (100g serving)",
          align: "start",
          value: "name"
        },
        { text: "Category", value: "category" }
      ],
      loading: true,
      label: null,
      menu: false,
      dates: [],
      tags: []
    };
  },
  components: {},
  watch: {
    res_saldoakhirsim(val) {
      this.itemData = val.nonSaham;
    }
  },
  methods: {
    showsaham(val) {
      if (val === "nonsaham") {
        this.label = "Non Saham";
        this.itemData = this.res_saldoakhirsim.nonSaham;
      } else {
        this.label = "Saham";
        this.itemData = this.res_saldoakhirsim.saham;
      }
    },
    filterByDate() {
      if (this.dates.length > 0) {
        this.$store.commit("shu/SET_STARTYEAR", this.dates[0]);
        this.$store.commit("shu/SET_ENDYEAR", this.dates[1]);
        this.$store.dispatch("shu/getSHUlist");
      }
    },
    clearFillter() {
      this.$store.commit("shu/SET_STARTYEAR", null);
      this.$store.commit("shu/SET_ENDYEAR", null);
      this.$store.dispatch("shu/getSHUlist");
      this.dates = [];
    },
    goBack() {
      this.$router.go(-1);
    },
    goToDetail(val) {
      console.log(val);
      this.$store.commit("simpanan/SET_RESMUTATIONSIM", []);
      this.$store.commit("simpanan/SET_DETAILSINPANAN", []);
      this.$router.push(
        `/simpanan/${val.saving_type}/detail/${val.account_number}?type=${this.label}`
      );
    },
    downloadSHU() {
      this.$store.dispatch("shu/getDownloadShu").then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "file.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    }
  }
};
</script>
